(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ext/dhtmlxgantt_undo", [], factory);
	else if(typeof exports === 'object')
		exports["ext/dhtmlxgantt_undo"] = factory();
	else
		root["ext/dhtmlxgantt_undo"] = factory();
})(window, function() {
return 